<script>
    import {router} from '../../lib/Router/Router.svelte';
    import AppIcon from "../icons/AppIcon.svelte";
    import user from "../../stores/user.js";
    import {nl2br} from "../../lib/lib.js";

    export let type = 'warning'; // 'info', 'success'
    export let icon = null;
    export let title = null;
    export let message = null;
    export let showLogin = false;
    export let showCheckin = false;
    export let showDashboard = false;
    export let internal = false;

    if (!icon) {
        icon = 'exclamation-triangle-solid';
    }

    if (message) {
        message = message.split("|").join("<br>");
    }

    const gotoCheckin = () => {
        router.go('/checkin')();
    }

    const gotoDashboard = () => {
        router.go('/')();
    }
</script>

<div class="page-info { type }" class:external={ !internal } class:internal={ internal }>
    <div class="content">
        <div class="icon">
            <AppIcon icon="{ icon }" strokeWidth="3" size="page"/>
        </div>
        {#if title}
            <h4 class="mb-2">{ title }</h4>
        {/if}
        {#if message}
            <p>{@html nl2br(message) }</p>
        {/if}
        <div class="mt-4">
            {#if showLogin}
                <button class="btn btn-link mb-1" on:click={ user.showLogin }>Sign In</button>
            {/if}
            {#if showCheckin}
                <button class="btn btn-primary btn-block mb-2" on:click={gotoCheckin}>On-Line Check In</button>
            {/if}
            {#if showDashboard}
                <button class="btn btn-primary btn-block" on:click={gotoDashboard}>Dashboard</button>
            {/if}
        </div>
    </div>
</div>

<style>
    .page-info {
        min-width: 300px;
        max-width: 100%;
        text-align: center;
    }

    .page-info.external {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .page-info.internal {
        margin: 2rem 0;
    }

    .page-info .icon {
        width: 150px;
        height: 150px;
        border: 8px solid #f87171;
        border-radius: 50%;
        margin: 0 auto 30px auto;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #f87171;
    }

    .page-info.info .icon {
        color: #c7d2fe;
        border-color: #c7d2fe;
    }

    .page-info.success .icon {
        color: #3b82f6;
        border-color: #3b82f6;
    }

    .page-info p {
        font-size: 1.2rem;
        font-weight: 500;
    }
</style>